// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2cy5D","inputWrap":"styles_inputWrap__3FpGy","input":"styles_input__32fbO"};